import React from 'react';
import { ValidationMessageTile } from 'web-ui-components/lib/layout/content';
import { Content } from '../../../infrastructure/content';

const AcceptError = ({ nonEdit, editClickError }) => (
  <Content>
    {({ someDetailsNotCompleted }) => (
      <div>
        {!nonEdit && editClickError && (
          <ValidationMessageTile messageText={someDetailsNotCompleted} />
        )}
      </div>
    )}
  </Content>
);
export default AcceptError;
